import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable(
    {
        providedIn: 'root'
    }
)
export class LoaderService {
    private _ignoreLoader = false;

    public status: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    setIgnoreLoader(value: boolean) {
        this._ignoreLoader = value;
    }

    display(value: boolean) {
        if(!this._ignoreLoader)
            this.status.next(value);
    }
    public show() {
        if(!this._ignoreLoader)
        this.status.next(true);
    }
    public hide() {
        // setTimeout(() => {
        if(!this._ignoreLoader)
            this.status.next(false);
        // }, 0);
    }
}